import { parseAsStringLiteral, useQueryState } from 'nuqs'

import { cn } from '@/lib/utils'

export interface AlphabetPaginatorProps {
  letters: string[]
  /** Volá se po změně písmene (např. pro návrat na první stránku). */
  onChange?: (letter: string | null) => void
  className?: string
}

/** Tichý rejstřík písmen nad seznamem kontaktů. */
export const AlphabetPaginator = ({ letters, onChange, className }: AlphabetPaginatorProps) => {
  const [letter, setLetter] = useQueryState('letter', parseAsStringLiteral(letters))

  const select = (value: string | null) => {
    setLetter(value)
    onChange?.(value)
  }

  const item = (value: string | null, label: string) => {
    const active = letter === value
    return (
      <button
        key={value ?? '__all'}
        type="button"
        aria-pressed={active}
        onClick={() => select(active && value !== null ? null : value)}
        className={cn(
          'inline-flex h-7 min-w-7 items-center justify-center rounded-md px-1.5 text-[13px] font-medium transition-colors',
          active ? 'bg-foreground text-background' : 'text-muted-foreground hover:bg-muted hover:text-foreground',
        )}
      >
        {label}
      </button>
    )
  }

  return (
    <nav aria-label="Filtrovat podle písmene" className={cn('flex flex-wrap items-center gap-0.5', className)}>
      {item(null, 'Vše')}
      {letters.map((l) => item(l, l === '' ? '#' : l))}
    </nav>
  )
}
